window.ProgressBar = require('progressbar.js');
window.flatpickr = require('flatpickr');

document.addEventListener("DOMContentLoaded", function (event) {
    // Graphs
    (function() {
        flatpickr('.flatpickr', {dateFormat: "d/m/Y"});

        let graphs = document.getElementsByClassName('cpd-points-snapshot-graph');

        if (graphs.length === 0) {
            return;
        }

        Array.prototype.forEach.call(graphs, function(graph) {
            let bar = new ProgressBar.Circle(graph, {
                strokeWidth: 6,
                easing: 'easeInOut',
                duration: 1400,
                color: graph.dataset.color,
                trailColor: '#d9d9d9',
                trailWidth: 6,
                text: {
                    value: graph.dataset.text
                }
            });

            bar.animate(graph.dataset.progress); // Number from 0.0 to 1.0
        });
    }());

    // Disable submit button on valid CPD hours record submit.
    let cpdSubmitButton = document.querySelector('.js-cpd-submit');
    let cpdForm = document.getElementById('iugo-membership-kiosk-cpd-form');

    if ( cpdForm && cpdSubmitButton  ) {
        cpdForm.noValidate = true;

        cpdForm.addEventListener('submit', function handleFormSubmit(event) {
            const isValid = cpdForm.reportValidity();
            if (isValid) {
                // Form is valid. Prevent duplicate Submit clicks.
                cpdSubmitButton.disabled = 'true';
            } else {
                event.preventDefault();
            }
        });
    }
});